export class AntPagination {
  constructor (data) {
    this.position = ['topRight'];
    this.pageSize = data.itemsPerPage;
    this.total = data.totalItems;
    this.startIndex = data.startIndex || 0;
    this.current = Math.floor(this.startIndex / this.pageSize) + 1 || 1;
  }
}
